import React from 'react'
import MacroFactbox, { type Props as MacroFactboxProps } from '../../../react4xp/components/MacroFactbox'

function FaktaboksMacro(props: MacroFactboxProps) {
  return (
    <MacroFactbox {...props} />
  )
}

export default (props: MacroFactboxProps) => <FaktaboksMacro {...props} />
